import moment from 'moment'

export default function formatDuration({ y: value = 0, x }) {
  return moment
    .duration(Number.parseFloat(value), 'seconds')
    .format('h[h] m[m] s[s]', {
      trim: 'both',
    })
}
